module.exports = __webpack_public_path__ + "img/13.101ce6ca.jpg";